<template>
  <div class="workflow-mobile-tabs" data-cy="workflow-mobile-tabs">
    <UITabContainer
      v-if="tabs.length"
      class="workflow-mobile-tab-container"
      :tabs="tabs"
      :defaultTabId="workflowMode"
      @tabChanged="onTabChanged"
    >
      <template v-slot:myWork>
        <WorkflowMobileView :mode="EnumWorkflowMode.My" />
      </template>
      <template v-slot:allWork>
        <WorkflowMobileView :mode="EnumWorkflowMode.All" />
      </template>
    </UITabContainer>
  </div>
</template>

<script setup lang="ts">
import UITabContainer from "@/shared/ui/tabs/tab-container.vue";
import WorkflowMobileView from "./WorkflowMobileView.vue";
import { EnumWorkflowMode } from "@/Domain/EnumWorkflowMode";

const urlParams = new URLSearchParams(window.location.search);
const workflowMode = urlParams.get("mode") == "my" ? "myWork" : "allWork";

const tabs = [
  {
    id: "myWork",
    label: "My Work",
  },
  {
    id: "allWork",
    label: "All Work",
  },
];

const onTabChanged = async function (tabId: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("mode", tabId == "myWork" ? "my" : "all");
  window.history.pushState({}, "", `${window.location.pathname}?${urlParams}`);
};
</script>

<style lang="scss">
.workflow-mobile-tabs {
  .tab-header {
    background: #222;
    border-bottom: unset;
    border-top: 1px solid #333;
  }

  .tab {
    color: #fff;

    &.active {
      color: #399CD3;
      border-color: #399CD3;
    }
  }
}
</style>
